<template>
  <div class="layout-startup">
    <QPageContainer>
      <div>
        <router-view v-slot="{ Component }">
          <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </QPageContainer>
    <QFooter class="column">
      <div class="layout-startup-img">
        <img alt="Extracadabra logo" src="@etab/assets/img/extracadabra_logo.svg" :draggable="false" />
      </div>
      <AppVersion class="app-version" />
    </QFooter>
  </div>
</template>

<script setup>
  import { onMounted, onBeforeUnmount } from "vue";
  import { useTransition } from "@core/composables";
  import { StatusBar } from "@core/plugins/mobile";
  import AppVersion from "@core/components/utils/AppVersion.component.vue";

  const { transition, show, hide } = useTransition("RIGHT");

  onMounted(() => {
    StatusBar.setBlackBackground();
    show();
  });

  onBeforeUnmount(() => {
    hide();
    StatusBar.setDefault();
  });
</script>

<style lang="scss">
  .layout-startup {
    $img-height: 150;
    color: white;
    background: url("~@etab/assets/img/launch_background.png") no-repeat center top fixed black;
    background-size: cover;
    display: flex;
    flex-direction: column;

    .q-page-container {
      > div {
        overflow: hidden; // hide animation outside of view

        .q-page {
          padding-top: 50px;
          > div,
          > form {
            margin: 0 auto;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }

    .q-footer {
      background-color: transparent;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;

      .layout-startup-img {
        img {
          height: $img-height * 1px;
        }
      }
      .app-version {
        align-self: flex-end;
        margin-right: 10px;
      }
    }

    @media (max-width: $breakpoint-xs) {
      $overlay-height: 360;

      .q-page-container {
        > div {
          min-height: $overlay-height * 1px;

          .q-page {
            > div,
            > form {
              padding: 10px;
              width: 100%;
              height: calc(70vh - 50px - env(safe-area-inset-top) - env(safe-area-inset-bottom));
              min-height: $overlay-height * 1px;
            }
          }
        }
      }

      .layout-startup-img {
        @media screen and (max-height: (($overlay-height + $img-height + 70) * 1px)) {
          display: none;
        }
      }
    }

    @media (min-width: $breakpoint-xs) {
      $overlay-height: 425;

      .q-page-container {
        > div {
          min-height: $overlay-height * 1px;

          .q-page {
            > div,
            > form {
              padding: 75px 10px 10px;
              width: 400px;
              height: calc(60vh - 50px - env(safe-area-inset-top) - env(safe-area-inset-bottom));
              min-height: $overlay-height * 1px;
            }
          }
        }
      }

      .layout-startup-img {
        @media screen and (max-height: (($overlay-height + $img-height + 150) * 1px)) {
          display: none;
        }
      }
    }
  }
</style>
